import { Modal, Spin } from 'antd';
import axios from '../../utils/AxiosUtil';
import React from 'react';
import ReactDOM from "react-dom";
// import { useSelector } from 'react-redux'
/**
 * 和后台通讯，并根据响应状态界面提示
 */


/**
 * @param {string} url axios请求地址
 * @param {obj} params axios请求参数
 * @onOkSuccess {function} 成功后提示框确定按钮的回调函数
 * @onOkError {function} 失败后提示框确定按钮的回调函数
 */
export function axiosPostAndHint(url, params, onOkSuccess, onOkError, time_out) {
    // console.log('post and hint');
    mask();
    axios.post('/fund' + url, params, {
        headers: {
            uid: sessionStorage.getItem('uid'),
            Authorization: 'Bearer ' + sessionStorage.getItem('token')
        },
        timeout: typeof time_out == 'number' ? time_out : 60000
    }).then((data) => {
        unmask();
        modalHint('success', data.data.msg, onOkSuccess);
    })
        .catch((e) => {
            unmask();
            if (e.response) {
                if (e.response ?.data ?.msg) {
                    modalHint('error', e.response ?.data ?.msg, onOkError);
                } else {
                    modalHint('error', '服务器错误：' + e.response ?.status, onOkError);
                }
            } else {
                if (typeof e == 'object') {
                    if (e ?.message.startsWith('timeout')) {
                        modalHint('error', '响应超时，请检查网络或联系管理员');
                    } else {
                        modalHint('error', '出错了：' + e);
                    }
                } else {
                    modalHint('error', '出错了：' + e);
                }
            }

        });
}

/**
 * 
 * @param {*} status 响应状态，如200 404
 * @param {*} content 提示内容 ReactNode
 * @param {*} onOk 点击确定按钮回调
 * @param {*} okText 确定按钮显示文字
 */
export function modalHint(status, content, onOk, okText = '确定') {
    var langValue = 0
    var lang = sessionStorage.getItem('langValue')
    if (lang) {
        langValue = lang
    }
    if (status == "success") {
        Modal.success({
            content,
            okText: langValue == 0 ? (okText + 'OK') : (langValue == 1 ? okText : 'OK'),
            onOk: onOk
        });
    } else if (status == "error") {
        Modal.error({
            content,
            okText: langValue == 0 ? (okText + 'OK') : (langValue == 1 ? okText : 'OK'),
            onOk
        });
    } else {
        console.error("status只能是字符串success或error");
    }
}

/**
 * 插入/更新 服务器通讯封装
 * @param {string} url 请求url
 * @param {Object} params 请求参数
 * @param {function} sucFunc 成功回调
 * @param {function} errFunc 失败回调
 * @param {Number} timeout 超时时间（ms）
 */
export function upSertAxios(url, params, sucFunc = null, errFunc = null, timeout = 30000) {
    mask();
    var langValue = 0
    var lang = sessionStorage.getItem('langValue')
    if (lang) {
        langValue = lang
    }
    axios.post('/fund' + url, params,
        {
            headers: {
                uid: sessionStorage.getItem('uid'),
                Authorization: 'Bearer ' + sessionStorage.getItem('token')
            },
            timeout: timeout
        })
        .then((data) => {
            unmask();
            var str = '操作成功'
            if (data ?.data ?.msg) {
                let en_msg = data.data.en_msg;
                en_msg = en_msg ? en_msg : '';
                str = langValue == 0 ? (data.data.msg + en_msg) : (langValue == 1 ? data.data.msg : en_msg);
            }
            modalHint('success',
                str,
                () => {
                    if (typeof sucFunc == 'function')
                        sucFunc(data);
                });
        })
        .catch((e) => {
            unmask();
            if (typeof errFunc == 'function')
                errFunc(e);
            modalHint('error', e ?.response ?.data ?.msg ? e.response.data.msg : '请求失败：' + e);
        });
}

/**
 * 查询 服务器通讯封装
 *  

 * @param {string} url 请求url
  * @param {Object} params 请求参数
  * @param {string} errTitle 错误提示标题，默认null，传值则覆盖 
  * @param {string}  errContent 错误提示内容，默认null，传值则覆盖
 * @param {number} timeout 超时时间（ms）
 */
export async function queryAxios(url, params, errTitle = null, errContent = null, timeout = 30000) {
    mask();
    let r = await axios.post('/fund' + url, params, {
        headers: {
            uid: sessionStorage.getItem('uid'),
            Authorization: 'Bearer ' + sessionStorage.getItem('token')
        },
        timeout: timeout
    })
        .then(data => {
            unmask();
            // console.log("*****data is", data);
            // Promise.resolve(data);
            return data;
        })
        .catch(e => {
            unmask();
            let msg;//报错讯息
            if (e ?.response ?.data.msg) {
                msg = e.response.data.msg;
            } else {
                msg = '(其他异常)' + e;
            }
            let cfg = { title: errTitle ? errTitle : '出了点问题：', content: errContent ? errContent + msg : msg };

            Modal.error(cfg);
            return null;
        })
    return r;
}

function getMaskEl() {
    let el = document.getElementById('tz-axios-mask');
    if (!el) {
        // console.log('no mask el,will create');
        el = document.createElement('div');
        el.id = 'tz-axios-mask';
        el.style.position = 'fixed';

        el.style.top = '0';
        el.style.left = '0';
        el.style.height = '100%';
        el.style.width = '100%';
        el.style.display = 'flex';
        el.style.justifyContent = 'center';
        el.style.alignItems = 'center';
        el.style.backgroundColor = 'rgba(0, 0, 0, 0.25)';
        el.style.zIndex = '999999';
    }
    return el;
}

// 遮罩 和unmask配对使用
export function mask(tip = '加载中...') {
    let el = getMaskEl();
    document.body.appendChild(el);
    ReactDOM.render(<Spin tip={tip} size='large'></Spin>, el)
}

//取消遮罩，和mask配对使用
export function unmask() {
    let el = document.getElementById('tz-axios-mask');
    if (el) {
        document.body.removeChild(el);
    }
}
